import { render, staticRenderFns } from "./TeamMemberView.vue?vue&type=template&id=39bb8574&"
import script from "./TeamMemberView.vue?vue&type=script&lang=js&"
export * from "./TeamMemberView.vue?vue&type=script&lang=js&"
import style0 from "./TeamMemberView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports